export default {
  title: 'Mooie avatar!',
  confirm: 'Wil je deze toevoegen aan je familie?',
  yes: 'Toevoegen',
  no: 'Terug'
};
